var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthprop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 623,
    viewBox: "0 0 441 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 57C106.473 40.3747 115.079 8.17404 145.721 12.3741C184.023 17.6242 223.39 64.8752 249.988 38.6247C276.587 12.3741 309.57 12.3741 350 12.3741",
    stroke: "#8769AB",
    strokeWidth: 24
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 402.5,
    r: 188,
    stroke: "#8769AB",
    strokeWidth: 65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthprop);
export default __webpack_public_path__ + "static/media/authprop.f2cbcb66a8299d41845c5c7cd070af63.svg";
export { ForwardRef as ReactComponent };